import { render, staticRenderFns } from "../views/qry_result.html?vue&type=template&id=0ccb3f22&"
import script from "../scripts/qry_result.ts?vue&type=script&lang=ts&"
export * from "../scripts/qry_result.ts?vue&type=script&lang=ts&"
import style0 from "./qry_result.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ujjwal/projects/opensource/idbstudio/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('0ccb3f22', component.options)
    } else {
      api.reload('0ccb3f22', component.options)
    }
    module.hot.accept("../views/qry_result.html?vue&type=template&id=0ccb3f22&", function () {
      api.rerender('0ccb3f22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/component/qry_result.vue"
export default component.exports